import React from "react";
import { Box, Grid2 } from "@mui/material";

const ThreeDotsLoader = () => {
    return (
        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh", // full screen center
                    gap: 1,
                }}
            >
                {[0, 1, 2].map((dot, index) => (
                    <Box
                        key={index}
                        sx={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: "#d1882a", // purple dots
                            animation: "bounce 0.6s infinite",
                            animationDelay: `${index * 0.2}s`,
                        }}
                    />
                ))}

                {/* Animation keyframes */}
                <style>
                    {`
          @keyframes bounce {
            0%, 80%, 100% { transform: scale(0); }
            40% { transform: scale(1); }
          }
        `}
                </style>
            </Box>
        </Grid2>
    );
};

export default ThreeDotsLoader;
